<template>
  <div ref="modalbox">
    <a-modal
      v-model="show"
      :centered="true"
      :keyboard="false"
      :footer="null"
      :bodyStyle="bodyStyle"
      :closable="false"
      :getContainer="() => this.$refs.modalbox"
    >
      <div class="headbox">
        <span>告警记录</span>
        <a-icon class="iconbtn" type="close" @click="close" />
      </div>
      <a-table
        ref="TableInfo"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      ></a-table>
    </a-modal>
  </div>
</template>

<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
};
import monitorType from "../business/monitor/monitorType";

export default {
  name: "AlarmRecord",
  data() {
    return {
      formItemLayout,
      form: this.$form.createForm(this),
      selectedRowKeys: [],
      loading: false,
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "100"],
        defaultCurrent: 1,
        defaultPageSize: 10,
        // showQuickJumper: true,
        // showSizeChanger: true,
        showTotal: (total, range) =>
          `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`,
      },
      dataSource: [],
      bodyStyle: {
        "padding-top": 0,
        "margin-top": "-10px",
      },
    };
  },
  props: {
    alarmType: {
      type: String,
      default: "",
    },
    alarmRecordVisiable: {
      require: true,
      default: false,
    },
  },
  computed: {
    show: {
      get: function () {
        return this.alarmRecordVisiable;
      },
      set: function () {},
    },
    columns() {
      let self = this;
      let columns = [
        {
          title: "站点名称",
          dataIndex: "areaName",
          className: "columndata",
        },
        {
          title: "设备",
          dataIndex: "alarmTypeName",
          className: "columndata",
        },
        {
          title: "报警类型",
          dataIndex: "alarmEventType",
          className: "columndata",
          customRender: (text, record) => {
            let arr =
              this.alarmType == 0
                ? monitorType.commerceEvent
                : this.alarmType == 1
                ? monitorType.householdEvent
                : monitorType.commerceRestaurantEvent;
            let index = arr.findIndex((item) => {
              return item.value == text;
            });
            return index > -1 ? `${arr[index].name}` : "";
          },
        },
        {
          title: "开始时间",
          dataIndex: "createTime",
          className: "columndata",
        },
        {
          title: "结束时间",
          dataIndex: "modifyTime",
          className: "columndata",
        },
      ];
      /* if (this.alarmType !== '0') {
        columns.splice(4, 1)
      } */
      return columns;
    },
    eventTypeList() {
      return this.alarmType != 1
        ? monitorType.commerceAlarmType
        : monitorType.householdAlarmType;
    },
  },
  watch: {
    alarmRecordVisiable() {
      if (this.alarmRecordVisiable) {
        this.getData();
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    callback(key) {
      this.alarmType = key;
      if (this.paginationInfo) {
        this.paginationInfo.current = 1;
      }
      this.getData();
    },
    handleTableChange(pagination, filters, sorter) {
      // 将这三个参数赋值给Vue data，用于后续使用
      this.paginationInfo = pagination;
      this.filteredInfo = filters;
      this.sortedInfo = sorter;

      this.getData({
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    },
    getData(params = {}) {
      this.loading = true;
      if (this.paginationInfo) {
        // 如果分页信息不为空，则设置表格当前第几页，每页条数，并设置查询分页参数
        this.$refs.TableInfo.pagination.current = this.paginationInfo.current;
        this.$refs.TableInfo.pagination.pageSize = this.paginationInfo.pageSize;
        params.pageSize = this.paginationInfo.pageSize;
        params.pageNum = this.paginationInfo.current;
      } else {
        // 如果分页信息为空，则设置为默认值
        params.pageSize = this.pagination.defaultPageSize;
        params.pageNum = this.pagination.defaultCurrent;
      }
      this.$get(
        this.alarmType === "0"
          ? "alarm-record-industry"
          : this.alarmType === "1"
          ? "alarm-record-hosehold"
          : "alarm-record-restaurant",
        {
          ...params,
          // isOver: true,
        }
      )
        .then((res) => {
          console.log(res);
          this.dataSource = res.data.rows;
          const pagination = { ...this.pagination };
          pagination.total = res.data.total;
          this.pagination = pagination;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-pagination-item-link {
  background-color: rgba(5, 51, 143, 0.898) !important;
  border: none !important;
  color: white !important;
  font-size: 0.6vw !important;
  i {
    font-size: 0.4vw !important;
  }
}
/deep/ .ant-pagination-item {
  background-color: rgba(5, 51, 143, 0.898);
}
/deep/ .ant-pagination-item a {
  color: white;
  font-size: 0.6vw;
}
/deep/ .columndata {
  background-color: rgb(36, 35, 35) !important;
  color: #fff !important;
  font-size: 0.7vw;
}
/deep/ .ant-modal-content,
/deep/ .ant-modal-header {
  border-bottom: 0;
  background-color: rgba(0, 51, 153, 0.898039215686275) !important;
  width: 50vw;
  padding: 0.4vw 0.6vw;
  // margin: 0 auto;
}
/deep/ .ant-modal-content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/deep/ .ant-modal-title {
  font-size: #fff !important;
}
/deep/ .ant-pagination-total-text {
  color: #fff !important;
  font-size: 0.55vw;
}
/deep/ .ant-table-placeholder {
  background-color: rgb(36, 35, 35) !important;
  color: white;
  font-size: 0.6vw;
}
/deep/ .ant-table-pagination.ant-pagination {
  margin: 0.6vw;
}
/deep/ .ant-calendar-picker {
  font-size: 0.6vw;
}
/deep/ .ant-calendar {
  width: 20vw !important;
}
.headbox {
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-left: 0.5vw;
  height: 5vh;
  font-size: 0.8vw;
  // background-color: #fff;
  position: relative;
  &::before {
    content: "";
    display: block;
    width: 0.2vw;
    height: 1.7vh;
    background-color: dodgerblue;
    position: absolute;
    left: -0.3vw;
    top: 50%;
    transform: translateY(-50%);
  }
}
.iconbtn:hover {
  cursor: pointer;
  font-size: 0.6vw;
}
.iconbtn {
  font-size: 0.6vw;
}
</style>



// WEBPACK FOOTER //
// src/views/bigscreen/AlarmRecord.vue